<script lang="ts">
  import { listPastClasses } from '$lib/api/classes';
  import type { ClassSummary } from '$lib/api/types';
  import InfiniteScroll from '../common/InfiniteScroll.svelte';
  import Loading from '../Loading.svelte';
  import TableError from '../TableError.svelte';
  import TableMessage from '../TableMessage.svelte';
  import ClassListTable from './ClassListTable.svelte';
  import { auth } from '$lib/stores/auth.svelte';

  interface Props {
    currentClassesPromise: Promise<ClassSummary[]>;
  }

  let { currentClassesPromise }: Props = $props();
</script>

<div class="d-flex mb-3 align-items-center">
  <h2 class="mb-0 flex-grow-1">Current & Upcoming Classes</h2>
  {#if auth.isAdmin}
    <a href="./classes/new" class="btn btn-primary">New Class</a>
  {/if}
</div>

{#await currentClassesPromise}
  <Loading />
{:then classes}
  <ClassListTable {classes} />
  {#if classes.length === 0}
    <TableMessage message="No current classes" />
  {/if}
{/await}

<h2 class="mt-5">Past Classes</h2>

<InfiniteScroll
  loadData={async (query, page, pageSize, signal) => {
    return await listPastClasses(page, pageSize);
  }}
  queryString=""
  minimumQueryStringLength={0}
>
  {#snippet dataRenderer(classes, query, shouldShowLoadingIndicator, error, loadingIndicator)}
    <ClassListTable {classes} />
    {#if error}
      <TableError {error} />
    {:else if shouldShowLoadingIndicator}
      {@render loadingIndicator()}
    {:else if classes.length === 0}
      <TableMessage message="No past classes" />
    {/if}
  {/snippet}
  {#snippet loadingIndicator()}
    <TableMessage message="Loading..." />
  {/snippet}
</InfiniteScroll>
